import React from 'react';
import { useSelector } from 'react-redux';
import { useSitemap, useLabels } from 'wsm-common-data';

const CompareHeader = () => {
	const labels = useLabels();
	const sitemap = useSitemap();
	const searchResultsPageAlias = useSelector(
		(state) => state.searchResultsPageAlias
	);

	return (
		<div className="d-flex justify-content-between p-4 py-lg-5 px-lg-6 compare-done-button bg-page-title border-bottom">
			<span className="h1">{labels.get('COMPARE_VEHICLES')}</span>
			<a
				className="text-muted text-decoration-underline d-flex align-items-center"
				href={sitemap.get(searchResultsPageAlias) || '#'}
			>
				{labels.get('DONE')}
			</a>
		</div>
	);
};

export default CompareHeader;
